<script>
export default {
  name: 'MenuItem',
  functional: true,
  props: {
    icon: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    path: {
      type: String,
      default: ''
    }
  },
  render (h, context) {
    const { icon, title, path } = context.props
    const vnodes = []

    if (icon) {
      vnodes.push(<svg-icon icon-class={icon} />)
    }

    if (title) {
      vnodes.push(<span slot='title'>{(title)}</span>)
      if (path) {
        let pathClass = path
        if (path.includes("/")) {
          pathClass = path.substring(1)
        }
        let $i = h('i', {
          attrs: {
            class: 'count-tip ' + pathClass
          }
        })
        vnodes.push($i)
      }
    }
    return vnodes
  }
}
</script>

<style scoped>
.count-tip {
  display: none;
  width: 16px;
  height: 16px;
  font-size: 12px;
  text-align: center;
  line-height: 16px;
  font-style: normal;
  position: absolute;
  right: 2px;
  top: 2px;
  border-radius: 50%;
  background: #f56c6c;
  color: #ffffff !important;
}
</style>
